import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=4c8e8bdc&scoped=true"
import script from "./contacts.vue?vue&type=script&lang=ts"
export * from "./contacts.vue?vue&type=script&lang=ts"
import style0 from "./contacts.vue?vue&type=style&index=0&id=4c8e8bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e8bdc",
  null
  
)

export default component.exports